import gql from 'fraql'

const workshopsFragments = {
  pizzaCookerTasks: gql`
    fragment _ on TaskWorkshop {
      id,
      order: orderByIdOrder {
        id,
        comment,
        idDay,
        kitchenComment
        forTime
        typeDelivery: typeDeliveryByIdTypeDelivery {
          keyword
        }
        priority
        brandName
        pizzaProducts {
          nodes {
            id,
            name,
            idCategory,
            count,
            group,
            deleted,
            product: productByIdProduct {
              composition
              components
            }
          }
        }
      },
      timeCreation,
      stageWorkshop
    }
  `,
  ORDER_TARGET_COUNT: gql`
    fragment _ on OrderTargetCount {
      inTarget
      outOfTarget
      notKnown
    }
  `
}
const workshopsQueries = {
  ORDERS_PIZZA_COOKER: gql`
    query {
      tasksPizzaCookerOrders {
        nodes {
          ${workshopsFragments.pizzaCookerTasks}
        }
      }
    }
  `,
  NEED_DOUGH_COUNT: gql`
    query {
      pizzaNeedDoughCount {
        big
        small
        pie
      }
    }
  `,
  PIZZA_DOUGH_ROLLED: gql`
    query {
      pizzaDoughCount {
        big
        small
        pie
      }
    }
  `,
  INCREASE_PIZZA_COUNT: gql`
    mutation increasePizzaDoughCount ($bigSize: Boolean!, $pie: Boolean!) {
      increasePizzaDoughCount(input: {count: 1, bigSize: $bigSize, pie: $pie}) {
        boolean
      }
    }
  `,
  GET_MOTIVATE_WORKSHOPS: gql`
    query getMotivateWorkshops ($workshopType: String!) {
      getMotivateWorkshops (workshopType: $workshopType) {
        tasksCount,
        lastOrderDoneTime,
        indicateSos
      }
    }
  `,
  TARGET_NOT_TARGET_COUNT: gql`
    query {
      statsCookerMotivationStatefull {
        earlierHours {
          ${workshopsFragments.ORDER_TARGET_COUNT}
        }
        currentHour {
          ${workshopsFragments.ORDER_TARGET_COUNT}
        }
      }
    }
  `
}
export default workshopsQueries
export {workshopsFragments}



// WEBPACK FOOTER //
// ./src/graphql/workshops.js